var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25049 1.5C6.83649 1.5 6.50049 1.836 6.50049 2.25V3H9.50049V2.25C9.50049 1.836 9.16449 1.5 8.75049 1.5H7.25049ZM11.0005 3V2.25C11.0005 1.00725 9.99324 0 8.75049 0H7.25049C6.00774 0 5.00049 1.00725 5.00049 2.25V3H1.25049C0.836488 3 0.500488 3.336 0.500488 3.75C0.500488 4.164 0.836488 4.5 1.25049 4.5H1.32924L2.60649 15.9983C2.73324 17.1383 3.69624 18 4.84299 18H11.158C12.3047 18 13.2677 17.1383 13.3937 15.9983L14.6717 4.5H14.7505C15.1645 4.5 15.5005 4.164 15.5005 3.75C15.5005 3.336 15.1645 3 14.7505 3H11.0005ZM13.1627 4.5H2.83824L4.09749 15.8325C4.14024 16.2128 4.46124 16.5 4.84299 16.5H11.158C11.5397 16.5 11.8607 16.2128 11.9035 15.8325L13.1627 4.5ZM6.50049 6.75C6.91449 6.75 7.25049 7.086 7.25049 7.5V13.5C7.25049 13.914 6.91449 14.25 6.50049 14.25C6.08649 14.25 5.75049 13.914 5.75049 13.5V7.5C5.75049 7.086 6.08649 6.75 6.50049 6.75ZM9.50049 6.75C9.91449 6.75 10.2505 7.086 10.2505 7.5V13.5C10.2505 13.914 9.91449 14.25 9.50049 14.25C9.08649 14.25 8.75049 13.914 8.75049 13.5V7.5C8.75049 7.086 9.08649 6.75 9.50049 6.75Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.b75301cce07beffc716b52e79d172d2e.svg";
export { ForwardRef as ReactComponent };